import { render, staticRenderFns } from "./IngresoTotal.vue?vue&type=template&id=334e5009&"
import script from "./IngresoTotal.vue?vue&type=script&lang=js&"
export * from "./IngresoTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports